import { Link } from 'react-router-dom';
import { formatSignFee } from '@/services/adapters';

export interface TrainingCardItem {
  id: number;
  type: string;
  topic: string;
  hospital: string;
  date: string;
  time: string;
  enrolled: number;
  capacity: number;
  /** 报名费（元，0 表示免费） */
  signFee: number;
  image: string;
}

interface TrainingCardProps {
  item: TrainingCardItem;
}

export default function TrainingCard({ item }: TrainingCardProps) {
  const isFull = item.enrolled >= item.capacity;
  const isMaster = item.type === '精研班';
  const feeText = formatSignFee(item.signFee);

  return (
    <Link
      to={`/activities/${item.id}`}
      className="group flex gap-4 md:gap-5 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative shrink-0 w-[120px] sm:w-[160px] h-[120px] sm:h-[130px] rounded-md overflow-hidden">
        <img
          src={item.image}
          alt={item.topic}
          title={`${item.topic} - ${item.hospital}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded ${
            isMaster ? 'bg-accent-500 text-background-50' : 'bg-primary-500 text-background-50'
          }`}
        >
          {item.type}
        </span>
      </div>

      <div className="flex flex-col flex-1 min-w-0">
        <h3 className="font-heading font-semibold text-base text-foreground-900 leading-snug text-balance line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.topic}
        </h3>
        <ul className="mt-3 space-y-1.5 text-sm text-foreground-600">
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 flex items-center justify-center text-primary-500">
              <i className="ri-calendar-line"></i>
            </span>
            <span className="whitespace-nowrap">{item.date}</span>
          </li>
          <li className="flex items-center gap-2 min-w-0">
            <span className="w-4 h-4 flex items-center justify-center text-primary-500">
              <i className="ri-map-pin-line"></i>
            </span>
            <span className="truncate">{item.hospital}</span>
          </li>
        </ul>
        <div className="mt-auto pt-3 flex flex-wrap items-center justify-between gap-x-2 gap-y-1.5">
          <span className="text-xs text-foreground-500">
            已报名 <span className="font-semibold text-primary-600">{item.enrolled}</span> / {item.capacity} 人
          </span>
          <span className="flex items-center gap-1.5">
            <span
              className={`text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${
                item.signFee > 0 ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-900'
              }`}
            >
              {feeText}
            </span>
            <span
              className={`text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${
                isFull ? 'bg-foreground-100 text-foreground-500' : 'bg-accent-100 text-accent-700'
              }`}
            >
              {isFull ? '已满员' : '报名中'}
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}